import { Button, Form, Input, Spin } from "antd";
import ImageUploader from "../../../components/image-uploader";
import { ImageWithFallback, ModalComponent } from "../../../components";
import { useCategories } from "../../../hooks";
import { useState } from "react";

const EditCategoryForm = ({ categoryId, onSubmit }) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { editCategory, categoryById, isLoading } = useCategories({
    autoFetch: false,
  });

  const [imageUrl, setImageUrl] = useState("");

  const handleFinish = async (values) => {
    const response = await editCategory({
      values: { ...values, id: categoryId, image: imageUrl },
    });
    if (response) onSubmit(response);
    setIsModalOpen(false);
    form.resetFields();
  };

  const setFormValues = (category) => {
    if (!category) return;

    form.setFieldsValue({
      name: category.name,
      type: category.type,
      description: category.description,
      image: category.image,
    });

    if (category.image) {
      setImageUrl(category.image);
    } else {
      setImageUrl("");
    }
  };

  const handleOpenModal = async () => {
    setIsModalOpen(true);

    try {
      const category = await categoryById({ categoryId });
      setFormValues(category);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  return (
    <ModalComponent
      title="Editar Categoría"
      isModalOpen={isModalOpen}
      setOpen={setIsModalOpen}
      onOpen={handleOpenModal}
      modalContent={
        isLoading ? (
          <Spin size="large" />
        ) : (
          <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Form.Item
              name="name"
              label="Nombre"
              rules={[{ required: true, message: "Requerido" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="type"
              label="Tipo"
              rules={[{ required: true, message: "Requerido" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="description"
              label="Descripción"
              rules={[{ required: true, message: "Requerido" }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>

            <Form.Item
              name="image"
              label="Imagen"
              valuePropName="fileList"
              getValueFromEvent={(e) => e.fileList}
            >
              <ImageUploader
                onSaved={(imageUrl) => {
                  form.setFieldsValue({ image: imageUrl });
                  setImageUrl(imageUrl);
                }}
              />
            </Form.Item>

            {imageUrl && (
              <ImageWithFallback
                src={imageUrl}
                alt={form.getFieldValue("name")}
                style={{ width: 100, marginBottom: 10 }}
              />
            )}

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Guardar
              </Button>
            </Form.Item>
          </Form>
        )
      }
    >
      <Button>Editar</Button>
    </ModalComponent>
  );
};

export default EditCategoryForm;
